import { MenuItem, TableCellProps } from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import BarekamText from "../../../pages/components/text";
import {
  CustomerData,
  MobileOrder,
  PartialUserData,
  TransformedOrder,
  TransformedUser,
} from "../../shared/model/customers-response.model";
import {
  ManagementTableColumn,
  ManagementTableColumns,
} from "../../shared/model/customers-table-column.model";
import {
  ClickableColumnContainer,
  OrderTableCell,
} from "../../../pages/orders/my/order-list/styled";
import BarekamButton, { SimpleButtons } from "../../../pages/components/button";
import { ThreeDot } from "../../../pages/components/three-dot/three-dot";
import {
  Message,
  MessageSections,
} from "../../../pages/components/message/message";
import { User } from "../../../pages/shared/models/user/user";
import { WarehouseModel } from "../../../pages/shared/models/order/warehouse.model";
import { useAppSelector } from "../../../redux/store";
import {
  UserStatusActionMessages,
  UserStatuses,
  UserStatusModel,
} from "../../../pages/shared/models/user/user-status";
import { MessageModel } from "../../../pages/shared/models/message.model";
import { supportedLanguages } from "../../../constants";
import { GapContainer } from "../../../pages/components/card/styled";
import {
  ProductCategoryModel,
  StoreModel,
} from "../../../redux/reducers/static-data.reducers";
import { CityModel } from "../../../pages/shared/models/cityModel";
import { ProvinceModel } from "../../../pages/shared/models/provinceModel";
import { RegionModel } from "../../../pages/shared/models/regionModel";
import {
  MessagesManagementActionTypes,
  StaticDataActionTypes,
} from "../../actions/action-types.enum";
import { ActionKeys } from "../../actions/action-keys.enum";
import { BlogPostModel } from "../../../pages/shared/models/blogModel";
import { OrderStates, OrderStatesActionMessages } from "../../../pages/shared/models/order/order-status";

export const ManagementTableRowCell = (props: ManagementTableCellProps) => {
  return (
    <OrderTableCell>
      <CellContent {...props} />
    </OrderTableCell>
  );
};

const CellContent = ({
  column,
  data,
  clicked,
  changeStatus,
  orderStateUpdate,
  onEdit,
  onDelete,
}: ManagementTableCellProps) => {
  const { languageId } = useAppSelector((state) => state.messagesReducer);

  if (data.hasOwnProperty("user")) {
    const row = data as CustomerData;

    switch (column.variant) {
      case ManagementTableColumns.NAME:
        return (
          <ClickableColumnContainer>
            <BarekamButton type={SimpleButtons.LINK} onClick={() => clicked(row)}>
              <BarekamText variant={"m"} bold>
                {`${row.user.firstName} ${row.user.lastName}`}
              </BarekamText>
            </BarekamButton>
          </ClickableColumnContainer>
        )
      case ManagementTableColumns.ADDRESS_LINE:
        return (
          <BarekamText variant={"m"}>
            {row.user.addressLine2ForLand}
          </BarekamText>
        )
      case ManagementTableColumns.TOTAL_ORDERS_COUNT:
        return (
          <BarekamText variant={"m"}>
            {row.orders && row.orders.filter(order => order._id).length}
          </BarekamText>
        )
      case ManagementTableColumns.TOTAL_WEIGHT:
        const totalWeight = row.orders && row.orders
          .map(order => order.weight || 0)
          .reduce((previousValue, currentValue) => previousValue + currentValue, 0)
        return (
          <BarekamText variant={"m"}>
            {totalWeight}
          </BarekamText>
        )
      case ManagementTableColumns.TOTAL_PAYMENTS:
        const totalPayments = row.orders && row.orders
          .reduce((count, order) => count + order.paymentInfo, 0)
        return (
          <BarekamText variant={"m"}>
            {totalPayments}
          </BarekamText>
        )
      case ManagementTableColumns.BALANCE:
        return (
          <BarekamText variant={"m"}>
            {row.user.hasOwnProperty('balance')
              ? (row.user as PartialUserData).balance
              : 0
            }
          </BarekamText>
        )
      case ManagementTableColumns.EMAIL:
        return (
          <BarekamText variant={"m"}>
            {row.user.email}
          </BarekamText>
        )
      case ManagementTableColumns.REGISTERED_DATE:
        return (
          <BarekamText variant={"m"}>
            {row.user.hasOwnProperty('dateCreated')
              ? moment((row.user as PartialUserData).dateCreated).format('DD/MM/YYYY HH:mm')
              : ''
            }
          </BarekamText>
        )
      case ManagementTableColumns.USER_STATUS:
        const userStatus = row.user.status;
        return (
          <BarekamText variant={"m"}>
            {userStatus ? (
              <Message
                messageKey={userStatus.name}
                sectionId={MessageSections.MAIN}
              />
            ) : (
              ""
            )}
          </BarekamText>
        );
      case ManagementTableColumns.ACTIONS:
        return (
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <ThreeDot>
                {UserStatuses.map(userStatus =>
                  <MenuItem key={userStatus.userStatusId}
                    onClick={() => changeStatus && changeStatus(row, userStatus)}>
                    <Message messageKey={UserStatusActionMessages[userStatus.userStatusId]} sectionId={MessageSections.MAIN} />
                  </MenuItem>
                )}
              </ThreeDot>
            </div>
          </div>
        )
      case ManagementTableColumns.WAREHOUSE:
      case ManagementTableColumns.CITY:
        const warehouse = (row.user as User).warehouse;

        return (
          <BarekamText variant={"m"}>
            {column.variant === ManagementTableColumns.WAREHOUSE ? warehouse?.addressLine1 : warehouse?.city}
          </BarekamText>
        )
      default:
        return <></>
    }
  } else if (data.hasOwnProperty("mobileOrder")) {
    const row = data as TransformedOrder;

    switch (column.variant) {
      case ManagementTableColumns.NAME:
        return (
          <ClickableColumnContainer>
            <BarekamButton
              type={SimpleButtons.LINK}
              onClick={() => clicked(row)}
            >
              <BarekamText variant={"m"} bold>
                {`${row.firstName} ${row.lastName}`}
              </BarekamText>
            </BarekamButton>
          </ClickableColumnContainer>
        );
      case ManagementTableColumns.ADDRESS_LINE:
        return (
          <BarekamText variant={"m"}>
            {row.address}
          </BarekamText>
        );
      case ManagementTableColumns.CITY:
        return (
          <BarekamText variant={"m"}>
            {row?.city}
          </BarekamText>
        );
      case ManagementTableColumns.ZIP_CODE:
        return (
          <BarekamText variant={"m"}>
            {row?.zipCode}
          </BarekamText>
        );
      case ManagementTableColumns.PROVINCE_COUNTRY:
        return (
          <BarekamText variant={"m"}>
            {row?.country}
          </BarekamText>
        );
      case ManagementTableColumns.ADDRESS:
        return (
          <BarekamText variant={"m"}>
            {row?.address}
          </BarekamText>
        );
      case ManagementTableColumns.USER_PHONE:
        return (
          <BarekamText variant={"m"}>
            {row?.mobileNumber}
          </BarekamText>
        );
      case ManagementTableColumns.NUMBER_OF_PARCELS:
        return (
          <BarekamText variant={"m"}>
            {row.quantity}
          </BarekamText>
        );
      case ManagementTableColumns.TOTAL_WEIGHT:
        return <BarekamText variant={"m"}>{row?.orderWeight}</BarekamText>;
      case ManagementTableColumns.TOTAL_ORDERS_COUNT:
        return (
          <BarekamText variant={"m"}>
            {row.orders ? row.orders : 0}
          </BarekamText>
        );
      case ManagementTableColumns.EMAIL:
        return <BarekamText variant={"m"}>{row.email}</BarekamText>;
      case ManagementTableColumns.REGISTERED_DATE:
        return (
          <BarekamText variant={"m"}>
            {moment((row).dateCreated).format(
              "DD/MM/YYYY HH:mm"
            )}
          </BarekamText>
        );
      case ManagementTableColumns.MOBILE_ORDER_STATUS:
        const userMobileStatus = row?.state;
        return (
          <BarekamText variant={"m"}>
            <Message
              messageKey={userMobileStatus}
              sectionId={MessageSections.MAIN}
            />
          </BarekamText>
        );
      case ManagementTableColumns.WAREHOUSE:
      case ManagementTableColumns.CITY:
        return (
          <BarekamText variant={"m"}>
            {row?.city}
          </BarekamText>
        );
      case ManagementTableColumns.ORDER_ACTIONS:
        return (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <ThreeDot>
              {OrderStates.map((orderState, index) => (
                <MenuItem
                  key={orderState.state}
                  onClick={() => orderStateUpdate && orderStateUpdate(row?.orderId, orderState)}
                >
                  <Message
                    messageKey={
                      OrderStatesActionMessages[index]
                    }
                    sectionId={MessageSections.MAIN}
                  />
                </MenuItem>
              ))}
            </ThreeDot>
          </div>
        );
      default:
        return <></>;
    }
  } else if (data.hasOwnProperty("mobileUser")) {
    const row = data as TransformedUser;

    switch (column.variant) {
      case ManagementTableColumns.NAME:
        return (
          <ClickableColumnContainer>
            <BarekamButton
              type={SimpleButtons.LINK}
              onClick={() => clicked(row)}
            >
              <BarekamText variant={"m"} bold>
                {`${row.firstName} ${row.lastName}`}
              </BarekamText>
            </BarekamButton>
          </ClickableColumnContainer>
        );
      case ManagementTableColumns.EMAIL:
        return <BarekamText variant={"m"}>{row.email}</BarekamText>;
      case ManagementTableColumns.USER_PHONE:
        return (
          <BarekamText variant={"m"}>
            {row?.mobileNumber}
          </BarekamText>
        );
      case ManagementTableColumns.ADDRESS:
        return (
          <BarekamText variant={"m"}>
            {row?.address}
          </BarekamText>
        );
      case ManagementTableColumns.TOTAL_ORDERS_COUNT:
        return (
          <BarekamText variant={"m"}>
            {row.quantity}
          </BarekamText>
        )
      case ManagementTableColumns.CITY:
        return (
          <BarekamText variant={"m"}>
            {row?.city}
          </BarekamText>
        );
      case ManagementTableColumns.PROVINCE_COUNTRY:
        return (
          <BarekamText variant={"m"}>
            {row?.country}
          </BarekamText>
        );
      case ManagementTableColumns.REGISTERED_DATE:
        return (
          <BarekamText variant={"m"}>
            {moment(row.dateCreated).format('DD/MM/YYYY HH:mm')}
          </BarekamText>
        )
      default:
        return <></>;
    }
  } else if (data.hasOwnProperty("warehouseId")) {
    const row = data as WarehouseModel;

    switch (column.variant) {
      case ManagementTableColumns.WAREHOUSE_NAME:
        return (
          <ClickableColumnContainer>
            <BarekamButton
              type={SimpleButtons.LINK}
              onClick={() => clicked(row)}
            >
              <BarekamText variant={"m"} bold>
                {row.name}
              </BarekamText>
            </BarekamButton>
          </ClickableColumnContainer>
        );
      case ManagementTableColumns.WAREHOUSE_CITY:
        return (
          <ClickableColumnContainer>
            <BarekamButton
              type={SimpleButtons.LINK}
              onClick={() => clicked(row)}
            >
              <BarekamText variant={"m"} bold>
                {row.city}
              </BarekamText>
            </BarekamButton>
          </ClickableColumnContainer>
        );
      case ManagementTableColumns.WAREHOUSE_COUNTRY:
        const { countries } = useAppSelector(
          (state) => state.staticDataReducer,
        );

        const [warehouseCountry] = useState(
          countries.find((country) =>
            country.warehouse.some(
              (warehouse) => warehouse.warehouseId === row.warehouseId,
            ),
          ),
        );

        return (
          <BarekamText variant={"m"}>
            {warehouseCountry ? warehouseCountry.name[languageId] : <></>}
          </BarekamText>
        );
      case ManagementTableColumns.WAREHOUSE_ADDRESS:
        return <BarekamText variant={"m"}>{row.addressLine1}</BarekamText>;
      case ManagementTableColumns.WAREHOUSE_PHONE:
        return (
          <BarekamText variant={"m"} align={"right"}>
            {row.phone}
          </BarekamText>
        );
      default:
        return <></>;
    }
  } else if (data.hasOwnProperty("messageId")) {
    const row = data as MessageModel;

    switch (column.variant) {
      case ManagementTableColumns.MESSAGE_NAME:
        const parsedMessage = JSON.parse(row.name);

        return (
          <>
            {supportedLanguages.map((abbr, index) => (
              <GapContainer style={{ whiteSpace: "nowrap" }} key={index}>
                <BarekamText variant={"m"}>{`${abbr}: `}</BarekamText>

                <BarekamText variant={"m"} maxWidth={20}>
                  {parsedMessage[index + 1] || `${abbr}_row.key`}
                </BarekamText>
              </GapContainer>
            ))}
          </>
        );
      case ManagementTableColumns.MESSAGE_KEY:
        return <BarekamText variant={"m"}>{row.key}</BarekamText>;
      case ManagementTableColumns.MESSAGE_SECTION:
        return <BarekamText variant={"m"}>{row.section}</BarekamText>;
      case ManagementTableColumns.ACTIONS:
        return (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <ThreeDot>
              <MenuItem
                key={"edit"}
                onClick={() =>
                  onEdit &&
                  onEdit(row, MessagesManagementActionTypes.EDIT_MESSAGE)
                }
              >
                <Message
                  messageKey={"edit_message"}
                  sectionId={MessageSections.MAIN}
                />
              </MenuItem>

              <MenuItem
                key={"delete"}
                onClick={() =>
                  onDelete &&
                  onDelete(row, MessagesManagementActionTypes.DELETE_MESSAGE)
                }
              >
                <Message
                  messageKey={"delete_message"}
                  sectionId={MessageSections.MAIN}
                />
              </MenuItem>
            </ThreeDot>
          </div>
        );
      default:
        return <></>;
    }
  } else {
    const row:
      | StoreModel
      | ProductCategoryModel
      | CityModel
      | ProvinceModel
      | BlogPostModel
      | RegionModel = data as any;

    switch (column.variant) {
      case ManagementTableColumns.STATIC_DATA_TITLE:
        return (
          <ClickableColumnContainer>
            <BarekamButton type={SimpleButtons.LINK} onClick={() => void 0}>
              <BarekamText variant={"m"} bold>
                {(row as BlogPostModel).title[languageId]}
              </BarekamText>
            </BarekamButton>
          </ClickableColumnContainer>
        );

      case ManagementTableColumns.STATIC_DATA_NAME:
        return (
          <ClickableColumnContainer>
            <BarekamButton type={SimpleButtons.LINK} onClick={() => void 0}>
              <BarekamText variant={"m"} bold>
                {(row as StoreModel).name}
              </BarekamText>
            </BarekamButton>
          </ClickableColumnContainer>
        );
      case ManagementTableColumns.STORE_STATUS:
        return (
          <BarekamText variant={"m"} bold>
            {(row as StoreModel)?.status}
          </BarekamText>
        );
      case ManagementTableColumns.STATIC_DATA_JSON_NAME:
        return (
          <ClickableColumnContainer>
            <BarekamButton type={SimpleButtons.LINK} onClick={() => void 0}>
              <BarekamText variant={"m"} bold>
                {(row as StoreModel).name && (row as StoreModel).name[languageId]}
              </BarekamText>
            </BarekamButton>
          </ClickableColumnContainer>
        );
      case ManagementTableColumns.PRODUCT_CATEGORY_DESCRIPTION:
        return (
          <ClickableColumnContainer>
            <BarekamText variant={"m"} bold>
              {(row as ProductCategoryModel).description[languageId]}
            </BarekamText>
          </ClickableColumnContainer>
        );
      case ManagementTableColumns.PROVINCE_COUNTRY:
        return (
          <ClickableColumnContainer>
            {(row as ProvinceModel).country?.name &&
              (row as ProvinceModel).country.name[languageId]}
          </ClickableColumnContainer>
        );
      case ManagementTableColumns.CITY_PROVINCE:
        return (
          <ClickableColumnContainer>
            {(row as CityModel).province?.name &&
              (row as CityModel).province.name[languageId]}
          </ClickableColumnContainer>
        );
      case ManagementTableColumns.REGION_CITY:
        return (
          <ClickableColumnContainer>
            {(row as RegionModel).city?.name &&
              (row as RegionModel).city.name[languageId]}
          </ClickableColumnContainer>
        );
      case ManagementTableColumns.ACTIONS:
        return (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <ThreeDot>
              <MenuItem
                key={"edit"}
                onClick={() =>
                  onEdit && onEdit(row, StaticDataActionTypes.EDIT)
                }
              >
                <Message
                  messageKey={ActionKeys[StaticDataActionTypes.EDIT]}
                  sectionId={MessageSections.MAIN}
                />
              </MenuItem>

              <MenuItem
                key={"delete"}
                onClick={() =>
                  onDelete && onDelete(row, StaticDataActionTypes.DELETE)
                }
              >
                <Message
                  messageKey={ActionKeys[StaticDataActionTypes.DELETE]}
                  sectionId={MessageSections.MAIN}
                />
              </MenuItem>
            </ThreeDot>
          </div>
        );
      default:
        return <></>;
    }
  }
};

interface ManagementTableCellProps extends TableCellProps {
  column: ManagementTableColumn;
  data: CustomerData | WarehouseModel | MessageModel | TransformedUser | TransformedOrder;
  clicked: (data: CustomerData | WarehouseModel | MessageModel | TransformedUser | TransformedOrder) => void;
  orderStateUpdate?: (orderId: number, orderUpdateData: any) => any
  changeStatus?: (data: CustomerData, status: UserStatusModel) => void;
  onEdit?: (data: any, action: any) => void;
  onDelete?: (data: any, action: any) => void;
}
